import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useCompanyNavigate from '../../utils/useCompanyNavigate';
import { Card, Form, Input, InputNumber, Button, message, Select, Switch } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { ys7DeviceApi } from '../../services/api';

const { Option } = Select;

const Ys7DeviceForm = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(false);
  const { id } = useParams();
  const navigate = useCompanyNavigate();
  const isEdit = !!id;

  useEffect(() => {
    if (isEdit) {
      fetchData();
    }
  }, [id]);

  const fetchData = async () => {
    setInitialLoading(true);
    try {
      const res = await ys7DeviceApi.detail(id);
      if (res.code === 200) {
        form.setFieldsValue(res.data);
      }
    } catch (err) {
      message.error('获取设备信息失败');
      navigate('/admin/ys7-devices');
    } finally {
      setInitialLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      if (isEdit) {
        await ys7DeviceApi.update(id, values);
        message.success('更新成功');
      } else {
        await ys7DeviceApi.create(values);
        message.success('添加成功');
      }
      navigate('/admin/ys7-devices');
    } catch (err) {
      message.error(err.message || (isEdit ? '更新失败' : '添加失败'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Card>
        <div style={{ marginBottom: 16 }}>
          <Button
            type="link"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate('/admin/ys7-devices')}
          >
            返回列表
          </Button>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{
            channel_no: 1,
            protocol_type: 'ezopen',
            is_active: true,
            sort_order: 0
          }}
        >
          <Form.Item
            name="name"
            label="设备名称"
            rules={[{ required: true, message: '请输入设备名称' }]}
          >
            <Input placeholder="例如：工厂大门监控" />
          </Form.Item>

          <Form.Item
            name="appkey"
            label="AppKey"
            rules={[{ required: true, message: '请输入 AppKey' }]}
          >
            <Input placeholder="萤石云 AppKey" />
          </Form.Item>

          <Form.Item
            name="appsecret"
            label="AppSecret"
            rules={[{ required: true, message: '请输入 AppSecret' }]}
          >
            <Input.Password placeholder="萤石云 AppSecret" />
          </Form.Item>

          <Form.Item
            name="device_serial"
            label="设备序列号"
            rules={[{ required: true, message: '请输入设备序列号' }]}
          >
            <Input placeholder="萤石云设备序列号" />
          </Form.Item>

          <Form.Item
            name="channel_no"
            label="通道号"
            rules={[{ required: true }]}
          >
            <InputNumber min={1} max={100} style={{ width: '100%' }} />
          </Form.Item>

          <Form.Item
            name="protocol_type"
            label="协议类型"
            rules={[{ required: true }]}
          >
            <Select placeholder="选择协议类型">
              <Option value="ezopen">ezopen (推荐)</Option>
              <Option value="hls">HLS</Option>
              <Option value="rtmp">RTMP</Option>
              <Option value="flv">FLV</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="sort_order"
            label="排序"
          >
            <InputNumber min={0} max={999} style={{ width: '100%' }} />
          </Form.Item>

          <Form.Item
            name="is_active"
            label="启用状态"
            valuePropName="checked"
          >
            <Switch checkedChildren="启用" unCheckedChildren="禁用" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              {isEdit ? '更新' : '添加'}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Ys7DeviceForm;
